import { render, staticRenderFns } from "./OrderSkuDetail.vue?vue&type=template&id=6316a614"
import script from "./OrderSkuDetail.vue?vue&type=script&lang=js"
export * from "./OrderSkuDetail.vue?vue&type=script&lang=js"
import style0 from "./OrderSkuDetail.vue?vue&type=style&index=0&id=6316a614&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports